import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  // cashTransactionsAPI = JSON.parse(localStorage.getItem('allApiLinks')!)?.cash_transactions.href;
  // selfAPI = JSON.parse(localStorage.getItem('allApiLinks')!)?.self.href;
  // dashBoardAPI = JSON.parse(localStorage.getItem('allApiLinks')!)?.dashboards.href;
  localData: any;
  sap_code: any;
  role: any;
  constructor(private http: HttpClient, private store: Store<any>) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data.authReducer;
        this.role = this.localData.userDetails?.role?.name;
      });
    if (this.localData?.userDetails?.user_entity_mappings) {
      this.sap_code =
        this.localData?.userDetails?.user_entity_mappings[0]?.sap_code;
    }
  }

  settlement(data: any) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('type', JSON.stringify(data.type));
    queryParams = queryParams.append('date_from', data.date_from);
    queryParams = queryParams.append('date_to', data.date_to);
    queryParams = queryParams.append('duration', JSON.stringify(data.duration));
    queryParams = queryParams.append('payer_sap_code', data.payer_sap_code);
    queryParams = queryParams.append(
      'dashboard',
      data?.dashboard ? data?.dashboard : false
    );

    return this.http.get<any>(
      `${this.localData?.allApiLinks?.cash_transactions?.href}`,
      { params: queryParams }
    );
  }

  fetchAllApiEndpoints() {
    return this.http.get<any>(`${this.localData?.loginDetails?.url}`);
  }

  fetchUserDetails() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/users/${this.localData?.otpVerifiedDetails?.id}`
    );
  }

  dashboardDetails() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.userDetails?.id}/businesses/${this.localData?.userDetails?.business?.id}/dashboards`
    );
  }

  activeOrders() {
    let queryParams = new HttpParams();
    if (this.role === 'store_manager') {
      queryParams = queryParams.append('ship_to_code', this.sap_code);
    } else if (this.role === 'payer') {
      queryParams = queryParams.append('payer_sap_code', this.sap_code);
    }
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/latest_orders`,
      { params: queryParams }
    );
  }

  favOrders() {
    let queryParams = new HttpParams();
    if (this.role === 'store_manager') {
      queryParams = queryParams.append('ship_to_code', this.sap_code);
    } else if (this.role === 'payer') {
      queryParams = queryParams.append('payer_sap_code', this.sap_code);
    }
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/re_order`,
      { params: queryParams }
    );
  }

  dashboardBanners() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/dashboard_banners`
    );
  }

  userBalance() {
    // JSON.parse(localStorage.getItem('allApiLinks')!)?.fetch_balance_url.href
    let queryParams = new HttpParams();
    if (this.role === 'payer') {
      queryParams = queryParams.append('payer_sap_code', this.sap_code);
    }
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.fetch_balance_url?.href}`,
      { params: queryParams }
    );
  }

  // getOrders(){
  //   this.http.get<any>('https://navendor-mulesoft-api-staging.herokuapp.com//businesses/13922/sap_digital_orders').subscribe({
  //     next: (res) => {
  //       console.log(res);

  //     },
  //     error: (err) => {
  //       console.log(err);

  //     }
  //   })
  // }

  downloadTransaction(data: any) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('invoice_number', data.invoice_number);
    queryParams = queryParams.append(
      'credit_control_area',
      data.credit_control_area
    );
    // JSON.parse(localStorage.getItem('allApiLinks')!)?.invoice_pdf_url.href
    return this.http.get(
      `${this.localData?.allApiLinks?.invoice_pdf_url?.href}`,
      { params: queryParams, responseType: 'arraybuffer' }
    );
  }

  downloadMonthTransaction(date_from, date_to) {
    const _path =
      this.localData?.allApiLinks?.get_statement_pdf?.href +
      `?date_from=${date_from}&date_to=${date_to}`;
    return this.http.get(`${_path}`, { responseType: 'arraybuffer' });
  }

  smsConsent(body: any) {
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/is_sms_notif_on`,
      body
    );
  }

   fetchUserList() {
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/switcher`,null
    );
  }
  surveyApi(body:any){
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/survey_results`,
      body
    );
  }
}
